import React from 'react'
import styles from '../CustomDomainModal.module.css'
import { getFirstPart, CopyIcon } from '../constants/utils'

const DNSTable = ({ data }) => {
  return (
    <>
      {data &&
        data?.records &&
        data?.records.map((record, index) => {
          return (
            <div className={styles.table} key={index}>
              <div className={styles.record}>
                <span className={styles.dnsLabel}>Type:</span>
                <span className={styles.dnsValue}>
                  {record?.type} <CopyIcon text={record?.type} />
                </span>
              </div>
              <div className={styles.record}>
                <span className={styles.dnsLabel}>Name/Host:</span>
                <span className={styles.dnsValue}>
                  {getFirstPart(record?.host)} <CopyIcon text={getFirstPart(record?.host)} />
                </span>
              </div>
              <div className={styles.record}>
                <span className={styles.dnsLabel}>Value:</span>
                <span className={styles.dnsValue}>
                  {record?.value}
                  <CopyIcon text={record?.value} />
                </span>
              </div>
            </div>
          )
        })}
    </>
  )
}

export default DNSTable
